import React from 'react';
import Translation from '../translation/translation';

function FSFNotAvailableLightBoxHeader() {
    return (
        <div className="fsf-na-light-box__header fsf-na-light-box-header">
            <Translation
                translationKey="fsf-moto-light-box-header"
                className="fsf-na-light-box-header__headline"
            />
        </div>
    );
}

export {FSFNotAvailableLightBoxHeader};